import { Domain, DomainFlattened } from '../entity.types';

export function flattenDomains(domains: Array<Domain>): Array<DomainFlattened> {
  const domainsFlattened: Array<DomainFlattened> = [];
  domains.forEach((domain) => {
    const { sub, ...domainCleaned } = domain;
    domainsFlattened.push({ ...domainCleaned, parentDomainKey: null });
    if (domain.sub.length > 0) {
      domain.sub.forEach((subDomain) => {
        domainsFlattened.push({ ...subDomain, parentDomainKey: domain.key });
      });
    }
  });
  return domainsFlattened;
}
